import {Injectable} from '@angular/core';
import { EnvironmentService } from '../enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService {
  constructor(private readonly environmentService: EnvironmentService) {
  }

  isActive(myToggle: string): boolean {
    return this.toggle('toggle_all_active') || this.toggle(myToggle);
  }

  private toggle(myToggle: string) {
    const toggle = this.environmentService.getToggle(myToggle) || '';
    return toggle.trim().toLowerCase() === 'true';
  }
}
